const fromNString = (value) => value.replace(/^(.{8})(.{4})(.{4})(.{4})(.{12})$/, '$1-$2-$3-$4-$5');

const toNString = (value) => value.replace(/-/g, '');

export {
    fromNString,
    toNString
};